import { IAgreementRepository } from "../types";
type AgmtCommProps = {
  agmtDetails: IAgreementRepository;
};
const AgmtOverrideComm = ({ agmtDetails }: AgmtCommProps) => {
  return (
    <div className="grid grid-cols-1 text-xs p-2 px-10 gap-y-2">
      <div className="grid grid-cols-2">
        <div className="text-gray-700">Override Commission:</div>
        <div className="font-semibold">
          {agmtDetails?.isOverridePayment ? "True" : "False"}
        </div>
      </div>

      {agmtDetails?.isOverridePayment && (
        <>
          <div className="grid grid-cols-2">
            <div className="text-gray-700">Override Payable:</div>
            <div className="font-semibold">
              {agmtDetails?.overridePaymentType}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 ml-2">
            <div className="text-gray-700 ">New Percentage:</div>
            <div className="font-semibold">
              {agmtDetails.overridePercentage != null
                ? parseFloat(agmtDetails.overridePercentage.toString()).toFixed(
                    2
                  ) + "%"
                : agmtDetails?.overridePercentage}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 ml-2">
            <div className="text-gray-700 ">Renewal Percentage:</div>
            <div className="font-semibold">
              {agmtDetails.overrideRenewalPercentage != null
                ? parseFloat(
                    agmtDetails.overrideRenewalPercentage.toString()
                  ).toFixed(2) + "%"
                : agmtDetails?.overrideRenewalPercentage}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AgmtOverrideComm;
